import type { IOwnAccountsTransferTemplateForm } from "@/modules/template/common/types";
import { OwnAccountsTransferTemplateForm } from "@/modules/template/components";
import { ownAccountsTransferTemplateValidationSchema } from "@/modules/template/validations";
import { Currencies } from "@/shared/common/enums";
import type { IOperationPageProps } from "@/shared/common/types";
import { PageHeader } from "@/shared/components";
import { useTranslationExists } from "@/shared/hooks";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";

export const OwnAccountsTransferTemplate = ({ isEdit }: IOperationPageProps) => {
  const { t } = useTranslationExists();

  const initialValues: IOwnAccountsTransferTemplateForm = {
    creditAccount: "",
    debitAccount: "",
    amount: "",
    name: "",
    purpose: "",
    currency: Currencies.AMD,
  };

  return (
    <>
      <FormContainer
        className="full-width page-container form-layout"
        formId="form-container"
        mode="onBlur"
        reValidateMode="onBlur"
        initialValues={initialValues}
        validationScheme={ownAccountsTransferTemplateValidationSchema({ t })}
      >
        <PageHeader/>
        <OwnAccountsTransferTemplateForm isEdit={isEdit}/>
      </FormContainer>
    </>
  );
};
